/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";

/**
 * Row of a group of the gate log: the label of the value on the left and, when
 * the value was registered by someone, the chip that identifies them.
 */
const GateLogValueBox = ({label, value, action, className = ''}) => {
    return (
        <div className={`d-flex justify-content-between align-items-start border-radius-8px background-shades-100 p-3 ${className}`}>
            {/* The value takes the room the chip leaves, so a long text wraps
                inside the row instead of pushing the chip out of it. */}
            <div className={"minw-0"}>
                <p className={"font-color-shades-500 ibl-font-w-600 fs-14px"}>{label}</p>
                <p className={"fs-14px"}>{value}</p>
            </div>
            {/* The chip only names who registered the value, so it keeps the
                size of its icon whatever the value is read with. */}
            {action &&
                <div className={"ml-2 flex-shrink-0"}>
                    {action}
                </div>
            }
        </div>
    );
};

export default GateLogValueBox;
